var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-control',{attrs:{"name":"credits"}},[_c('vue-editor',{staticStyle:{"max-width":"700px"},attrs:{"name":"credits","editor-toolbar":['link'],"value":_vm.initialText}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }